import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import InstituteTemplate from "../../Components/InstituteTemplate/InstituteTemplate";
import DesktopTabsForEnrolledStudents from "./DesktopTabsForEnrolledStudents/DesktopTabsForEnrolledStudents";
import { useParams } from "react-router-dom";
import UpcomingClassesSchedule from "./UpcomingClassesSchedule/UpcomingClassesSchedule";
import { GetCourseNameA } from "../../Actions/StudentA";
import { GetAboutInfoA } from "../../Actions/CourseA";

const InstituteEnrolledStudentsInformationChild= () => {
    const { EnrollmentId } = useParams();

    const Dispatch = useDispatch();
    const { CourseName } = useSelector((Store) => Store.StudentReducer);
    console.log("CourseName in ClassesSchedule is:", CourseName);
    console.log(
    "CourseName?.courseName in ClassesSchedule is:",
    CourseName?.courseName
    );

    const [activeTab, setActiveTab] = useState("UpcomingClasses");

    useEffect(() => {
        if (EnrollmentId) {
          Dispatch(GetCourseNameA(EnrollmentId));
          Dispatch(GetAboutInfoA(EnrollmentId)); 
        }
        
      }, [Dispatch, EnrollmentId]);
   
     // Function to render the right-side content based on the active tab
    const renderContent = () => {
         switch (activeTab) {
            case "UpcomingClasses":
                return <UpcomingClassesSchedule EnrollmentId={EnrollmentId} />;
            default:
                return <UpcomingClassesSchedule EnrollmentId={EnrollmentId} />;
         }
     };
    
    return (
        <>
            <DesktopTabsForEnrolledStudents setActiveTab={setActiveTab} activeTab={activeTab} CourseName={CourseName} />
            <div className="pb-[100px] bg-[#FFFFFF]">
                {renderContent()}
            </div>
        </>
    );
};

const InstituteEnrolledStudentsInformation = () => (
    <InstituteTemplate
      Element={InstituteEnrolledStudentsInformationChild}
      m_top="mt-0"
      bg="bg-[#F0F0F7]"
    />
  );

export default InstituteEnrolledStudentsInformation;
